import styles from "./MarkAsCompleteHeader.module.css";
import {useSelector} from "react-redux";
import SubmitAllDocumentsHeader from "../SubmitAllDocumentsHeader/SubmitAllDocumentsHeader";
import {userIsDocCollector} from "../../helpers/users";

interface Props {
    inspectionEnd: string;
    openModal: () => void;
}

export default function MarkAsCompleteHeader({
    inspectionEnd,
    openModal
}: Props) {
    const isDocumentCollector: boolean = useSelector((state: any) =>  userIsDocCollector(state));

    return isDocumentCollector ?
           <SubmitAllDocumentsHeader openModal={openModal}/>
        :
            <div className={styles.markAsCompleteHeader}>
                <p className={styles.submissionDate}>
                    Submission Deadline: {inspectionEnd}
                </p>
                <div className={styles.markCompleteButtonWrapper}>
                    <button
                        className={styles.buttonColour}
                        onClick={openModal}
                        data-cy="markCompleteButton"
                    >
                        Mark Section Complete
                    </button>
                </div>
            </div>
}
